// Used outside of the normal RestController flow to allow control over authorization token
export const GET_USER_IF_EXISTS = '/api/v1/user/if/exists';
